import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import {
  ProductConfPackage,
  productConfPackages,
  ProductConfNames,
} from "../../file.interface";
import { formatAsEuro } from "../../helpers/helpers";
import { ScreenContainer } from "../../components/containers";

const PoductConfScreen6: React.FC = () => {
  const { selectedProductConfPackage, dispatch } = useAppContext();
  const navigate = useNavigate();

  const handleProductConf = (item: ProductConfPackage): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedProductConfPackage: item },
    });
  };

  return (
    <ScreenContainer
      title="Product Configuration"
      subtitle="Choose one of the following packages"
    >
      <div className="package-container">
        {productConfPackages.map((_package, i) => {
          let packagePrice: string | number = formatAsEuro(_package.price);
          if (_package.packageName === ProductConfNames.buildYourOwn)
            packagePrice = "";
          if (_package.packageName === ProductConfNames.basic)
            packagePrice = "FREE";
          return (
            <div
              key={i}
              className={`${
                _package === selectedProductConfPackage
                  ? "card-package-selected"
                  : ""
              } card-package`}
              onClick={() => handleProductConf(_package)}
            >
              {/*               <div className="green-tag">
                {_package.recommended ? "RECOMMENDED" : " "}
              </div> */}

              <div className="price-section">
                <div className="orange-title">{_package.packageName}</div>
                <div className="package-price">{packagePrice}</div>
              </div>
              <ul>
                {_package.description.split("\n").map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
        {selectedProductConfPackage && (
          <button
            className="app-button next-button"
            onClick={() => navigate("/support-screen-6")}
          >
            Next
          </button>
        )}
      </div>
    </ScreenContainer>
  );
};

export default PoductConfScreen6;
